module.exports = __webpack_public_path__ + "img/Aruba.c08af88c.svg";